import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons"
import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import { fileActions } from "../../../../../store/files-slice"
import InfoIcon from "../../../../InfoIcon"

const Resort = (props) => {
    const { type } = props

    const { resort } = useFilter()
    let filteredfiles = useSelector((state) => state.log.filteredfiles)
    let files = useSelector(state => state.file.files)

    let dispatch = useDispatch()


    return <Fragment>
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowUp} onClick={() => {

            dispatch(fileActions.setFilteredItems(resort(filteredfiles ?? files, type, 'ASC')))
        }} />
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowDown} onClick={() => {
            dispatch(fileActions.setFilteredItems(resort(filteredfiles ?? files, type, 'DESC')))
        }} />
    </Fragment>
}

export default Resort